import LogoFooter from "../../assets/logo-kasa_footer.svg"
function Fooder() {
    return (
        <footer>
            <img src={LogoFooter} alt='Kasa' />
            <p>© 2020 Kasa. All rights reserved</p>
        </footer>
    )
}
export default Fooder